import type { IMasterDataRetailerMatchRuleRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataRetailerMatchRulesDTO } from "@src/domain/dto/masterData";

export class GetMasterDataRetailerMatchRulesUseCase {
  private readonly repository: IMasterDataRetailerMatchRuleRepository;

  constructor(repository: IMasterDataRetailerMatchRuleRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataRetailerMatchRulesDTO) {
    return this.repository.getMatchRules(params);
  }
}
